import EcoImg from 'eco-design/base/eco-img';
import { useEffect, useRef, useState } from 'react';
import EcoVideo from 'eco-design/base/eco-video';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen1() {
    const { t } = useLang('theProductV2.Screen1');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen1-V2');

    const containerRef = useRef(null);
    const [enter, setEnter] = useState(false);
    useEffect(() => {
        if (!containerRef.current) return;
        if (typeof window === 'undefined') return;
        if (window.innerWidth <= 1024) return;
        const ani = AniContainer.create({
            triggerElement: '.temp-rapid-mag-Screen1-V2',
            triggerHook: 1,
            offset: '100%',
            duration: '200%',
            onProcess: (process: number) => {
                setEnter(process > 0.5);
            },
        });

        return () => {
            ani.destroy?.();
        };
    }, []);

    useEffect(() => {
        const video = document.querySelector('.temp-rapid-mag-Screen1-V2 .screen2 video') as HTMLVideoElement;
        if (!video) return;
        if (enter) {
            video.currentTime = 0;
            video.play();
        } else {
            video.pause();
            video.currentTime = 0;
        }
    }, [enter]);

    // 控制视频播放
    useEffect(() => {
        if (typeof window === 'undefined') return;
        if (window.innerWidth <= 1024) return;
        const ani1 = AniContainer.create({
            triggerElement: '.temp-rapid-mag-Screen1-V2 .screen1',
            triggerHook: 1,
            offset: '80%',
            duration: '120%',
            onEnter: () => {
                const video = document.querySelector('.temp-rapid-mag-Screen1-V2 .screen1 video') as HTMLVideoElement;
                if (video) {
                    video.currentTime = 0;
                    video.play();
                }
            },
            onProcess: (process: number) => {
                if (process <= 0 || process >= 1) {
                    const video = document.querySelector('.temp-rapid-mag-Screen1-V2 .screen1 video') as HTMLVideoElement;
                    if (video) {
                        video.pause();
                        video.currentTime = 0;
                    }
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);

    // 控制 charging
    const [chargingBar, setChargingBar] = useState(false);
    useEffect(() => {
        const charging = document.querySelector('.temp-rapid-mag-Screen1-V2 .screen1 .charging-speed');
        if (!charging) return;
        const callback = (entries: IntersectionObserverEntry[]) => {
            entries.forEach((entry) => {
                setChargingBar(entry.isIntersecting);
            });
        };
        const observer = new IntersectionObserver(callback, {
            threshold: 1,
        });
        observer.observe(charging);
        return () => {
            observer.disconnect();
        };
    }, []);

    const speeds = [
        {
            name: t('name1'),
            minutes: t('minutes1'),
            width: '45%',
            color: '#63FF78',
        },
        {
            name: t('name2'),
            minutes: t('minutes2'),
            width: '70%',
            color: 'linear-gradient(90deg, #DCDCDC 0%, #B6B6B6 100%)',
        },
    ];

    return (
        <section
            className={`${css.comp} temp-rapid-mag-Screen1-V2  GtmModuleData-section`}
            id="rapid-mag-Screen1-V2"
            data-section-id={'rapid-mag-Screen1-V2'}
            data-section-title={t('title')}
            ref={containerRef}
        >
            <div className="sticky-container">
                <div className={`screen1 ${enter ? 'hide' : 'show'}`}>
                    <div className="screen-info">
                        <EcoImg
                            className="info-img"
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1761880390200/icon.png',
                                'https://websiteoss.ecoflow.com/upload/image/1761880390401/icon.webp',
                            )}
                        />
                        <div className="screen-label">{t('label')}</div>
                        <div className="screen-title">{t('title')}</div>
                        <div className="screen-desc">{t('desc')}</div>
                        <div className="screen-tips">{t('tips')}</div>
                        <div className="charging-speed">
                            {speeds.map((i, idx) => (
                                <div className="charging-speed-item" key={idx}>
                                    <div className="charging-name">{i.name}</div>
                                    <div className="charging-bar">
                                        <div className="charging-bar-inner" style={{ width: chargingBar ? i.width : 0, background: i.color }}></div>
                                    </div>
                                    <div className="charging-minutes">{i.minutes}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <EcoVideo autoPlay loop pc="https://websiteoss.ecoflow.com/upload/video/1762243869391/wx.mp4" />
                </div>
                <div className={`screen2 ${enter ? 'show' : 'hide'}`}>
                    <div className="screen-info">
                        <EcoImg
                            className="info-img"
                            pc={webpOrJpg(
                                'https://websiteoss.ecoflow.com/upload/image/1761880390200/icon.png',
                                'https://websiteoss.ecoflow.com/upload/image/1761880390401/icon.webp',
                            )}
                        />
                        <div className="screen-label">{t('label2')}</div>
                        <div className="screen-title">{t('title2')}</div>
                        <div className="screen-desc">{t('desc2')}</div>
                    </div>
                    <EcoVideo autoPlay loop pc="https://websiteoss.ecoflow.com/upload/video/1762243869704/yx.mp4" />
                </div>
            </div>
        </section>
    );
}
